import NavBar from '../components/NavBar';
import { CoreNavRail } from '../components/CoreNavRail';
import { useThemeStore } from '../store/themeStore';
import { getDesignTokens } from '../utils/designTokens';
import { releaseNotes } from '../utils/releaseNotes';

export default function WhatsNew() {
  const { isDarkMode } = useThemeStore();
  const tokens = getDesignTokens(isDarkMode);

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString + 'T00:00:00');
    return date.toLocaleDateString('en-US', { 
      year: 'numeric',
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className={`h-screen ${tokens.bg.gradient} relative flex flex-col overflow-hidden pr-20 transition-colors duration-300`}>
      <NavBar className={`${tokens.card.bg} ${tokens.card.shadow} ${tokens.card.border} border`} containerClassName="px-3 py-2">
        <div className="flex items-center gap-3">
          <span className={`text-lg font-semibold ${tokens.text.primary} font-serif`}>What's New</span>
          <span className={`text-sm ${tokens.text.muted}`}>Latest features and updates</span>
        </div>
      </NavBar>

      <div className="flex-1 overflow-auto pt-0 px-2 pb-2">
        <div className={`max-w-4xl mx-auto space-y-4 py-4`}>
          {releaseNotes.length === 0 ? (
            <div className={`${tokens.card.bg} ${tokens.card.border} border rounded-landing ${tokens.card.shadow} p-8 text-center`}>
              <p className={`text-lg ${tokens.text.muted}`}>No release notes yet. Check back soon!</p>
            </div>
          ) : (
            releaseNotes.map((release, index) => (
              <div
                key={index}
                className={`${tokens.card.bg} ${tokens.card.border} border rounded-landing ${tokens.card.shadow} p-4 touch-manipulation`}
              >
                {/* Header */}
                <div className="mb-3">
                  <div className="flex items-center gap-3 mb-2">
                    {release.version && (
                      <span className={`px-2 py-1 rounded-landing text-xs font-semibold ${tokens.button.primary} ${tokens.text.inverse}`}>
                        v{release.version}
                      </span>
                    )}
                    <span className={`text-sm font-medium ${tokens.text.muted}`}>
                      {formatDate(release.date)}
                    </span>
                  </div>
                  <h3 className={`text-xl font-semibold ${tokens.text.primary} mb-1`}>
                    {release.title}
                  </h3>
                  {release.description && (
                    <p className={`text-sm ${tokens.text.secondary}`}>
                      {release.description}
                    </p>
                  )}
                </div>

                {/* Features */}
                {release.features && release.features.length > 0 && (
                  <ul className={`space-y-2 mt-4`}>
                    {release.features.map((feature, featureIndex) => (
                      <li
                        key={featureIndex}
                        className={`flex items-start gap-2 text-sm ${tokens.text.primary}`}
                      >
                        <span className={`mt-1 ${tokens.text.accent}`}>•</span>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      <CoreNavRail active="account" />
    </div>
  );
}
